import { Controller } from "@hotwired/stimulus"

// Voyant « en ligne » du tableau de bord admin : compte des visiteurs actifs
// (5 dernières minutes), rafraîchi toutes les 10 s. Fire-and-forget : une
// erreur réseau laisse simplement la dernière valeur affichée.
const REFRESH_MS = 10000

export default class extends Controller {
  static targets = ["count", "detail"]
  static values = { url: String }

  connect() {
    this._timer = setInterval(() => this.refresh(), REFRESH_MS)
  }

  disconnect() {
    clearInterval(this._timer)
  }

  async refresh() {
    try {
      const r = await fetch(this.urlValue, { headers: { Accept: "application/json" } })
      if (!r.ok) return
      const { active, signed_in } = await r.json()
      this.countTarget.textContent = active
      if (this.hasDetailTarget) {
        this.detailTarget.textContent = signed_in > 0 ? `dont ${signed_in} avec compte` : ""
      }
    } catch (e) {}
  }
}
